/* eslint-disable jsx-a11y/alt-text */
import Div from '@/shared/Div';
import React, { Fragment, memo } from 'react';
import Paragraph from '@/shared/Paragraph';
import Divider from '@/shared/Divider';
import Button from '@/shared/Button';
import ChevronIcon from '../Icons/Chevron';
import Map from '../Map';
import Image from '@/shared/Image';

function BenefitsList({ title, ctas, list, icon }: any) {
  return (
    <Div className="px-8 pt-8 pb-6 rounded-cs border border-co-subtle max-w-screen-md mx-auto w-full  bg-white">
      <Div className="flex flex-col gap-s5 md:gap-s7">
        <Div className="flex flex-col md:flex-row gap-s5 md:gap-s5 md:items-center">
          <Image width={72} height={72} cmsImage={icon} />
          <Paragraph className="text-h-2 text-black/70 md:text-hd-2">{title}</Paragraph>
        </Div>

        <Map
          list={list}
          className="flex flex-col gap-s3 md:gap-s4"
          render={({ text, icon }, index) => {
            return (
              <Fragment key={text + index}>
                <Div className="flex justify-between items-center">
                  <Paragraph className="text-black/70 text-body-sm md:text-body-xl">
                    {text}
                  </Paragraph>
                  {icon ? <Image width={24} height={24} cmsImage={icon} /> : null}
                </Div>
                <Divider className="last:hidden" />
              </Fragment>
            );
          }}
        />

        <Map
          list={ctas}
          render={(cta) => (
            <Button
              key={`cta-${cta.label}`}
              className="flex !justify-start !gap-0 !pl-0 text-button-small md:text-button-normal"
              theme="link"
              href={cta.href}
            >
              {cta.label}
              <ChevronIcon />
            </Button>
          )}
        ></Map>
      </Div>
    </Div>
  );
}

export default memo(BenefitsList);
